module.exports = __webpack_public_path__ + "static/media/living-room.d61a4a8d.mp3";